export default __webpack_public_path__ + "static/media/124_chronoklok.c0c73c86.png";